import React, { useState } from 'react';

interface TruncatedDescriptionProps {
  description: string;
  maxLength?: number;
  topicId: string;
}

const TruncatedDescription: React.FC<TruncatedDescriptionProps> = ({ 
  description, 
  maxLength = 150,
  topicId 
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  // Handle null, undefined, or empty descriptions
  if (!description || description.trim().length === 0) {
    return <span style={{ color: '#999', fontStyle: 'italic' }}>No description provided</span>;
  }

  const trimmedDescription = description.trim();
  
  // If description is within limit, show it all
  if (trimmedDescription.length <= maxLength) {
    return <span style={{ whiteSpace: 'pre-line' }}>{trimmedDescription}</span>;
  }

  // Truncate at maxLength
  const truncated = trimmedDescription.substring(0, maxLength);

  return (
    <span style={{ whiteSpace: 'pre-line' }}>
      {isExpanded ? trimmedDescription : truncated}
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        style={{
          background: 'none',
          border: 'none',
          color: '#6b7280',
          cursor: 'pointer',
          padding: '0 0 0 4px',
          fontSize: '0.875em',
          textDecoration: 'none',
          fontWeight: '500'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.color = '#2563eb';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.color = '#6b7280';
        }}
      >
        {isExpanded ? '...show less' : '...show more'}
      </button>
    </span>
  );
};

export default TruncatedDescription;
